module.exports = __webpack_public_path__ + "static/Filippo-abc3ed720ed0ccef586d6e1e7531f2cd.png";